import React, { useState } from "react";
import PriceRangeInput from "./PriceRangeInput";
import convertNumbThousand from "utils/convertNumbThousand";
import SearchInput from "../SearchInput";
import { useGetCitiesQuery } from "store/api";
import OptionSelect from "./OptionSelect";

const FilterFormSearch = () => {
  //
  const [fieldNameShow, setFieldNameShow] = useState<
    "category" | "city" | "location" | "price"
  >("location");
  //

  const {data:dataCities} = useGetCitiesQuery({});
  const categories = ['Todos','Concierto','Formación Profesional','Entretenimiento','Cultura','Deportes','Turismo','Otros'];
  let cities = dataCities?.cantons || [];
   cities = cities.map((item:any) => item.city.description);

  const[category,setCategory]=useState('');
  const [city, setCity] = useState("");
  const [locationInputTo, setLocationInputTo] = useState("");
  const [rangePrices, setRangePrices] = useState([100000, 4000000]);

  const renderInputLocation = () => {
    const isActive = fieldNameShow === "location";
    return (
      <div
        className={`w-full bg-white dark:bg-neutral-800 ${
          isActive
            ? "rounded-2xl shadow-lg"
            : "rounded-xl shadow-[0px_2px_2px_0px_rgba(0,0,0,0.25)]"
        }`}
      >
        {!isActive ? (
          <button
            className={`w-full flex justify-between text-sm font-medium p-4`}
            onClick={() => setFieldNameShow("location")}
          >
            <span className="text-neutral-400">Where</span>
            <span>{locationInputTo || "Location"}</span>
          </button>
        ) : (
          <SearchInput
            headingText="Buscar"
            placeholder="Nombre del evento"
            defaultValue={locationInputTo}
            onChange={(value) => {
              setLocationInputTo(value);
              setFieldNameShow("location");
            }}
          />
        )}
      </div>
    );
  };

  const renderInputFilter = (label:string,field: "category" | "city" | "location" | "price",filters:any[], stateField:string,setStatefield:React.Dispatch<React.SetStateAction<string>>) => {
    const isActive = fieldNameShow === field;

    return (
      <div
        className={`w-full bg-white dark:bg-neutral-800 overflow-hidden ${
          isActive
            ? "rounded-2xl shadow-lg"
            : "rounded-xl shadow-[0px_2px_2px_0px_rgba(0,0,0,0.25)]"
        }`}
      >
        {!isActive ? (
          <button
            className={`w-full flex justify-between text-sm font-medium p-4`}
            onClick={() => setFieldNameShow(field)}
          >
            <span className="text-neutral-400">{label}</span>
            <span className="truncate ml-5">
              {stateField || "Todos"}
            </span>
          </button>
        ) : (
          <OptionSelect
            defaultValue={stateField}
            onChange={setStatefield}
            categories={filters}
          />
        )}
      </div>
    );
  };

  const renderInputPrice = () => {
    const isActive = fieldNameShow === "price";

    return (
      <div
        className={`w-full bg-white dark:bg-neutral-800 overflow-hidden ${
          isActive
            ? "rounded-2xl shadow-lg"
            : "rounded-xl shadow-[0px_2px_2px_0px_rgba(0,0,0,0.25)]"
        }`}
      >
        {!isActive ? (
          <button
            className={`w-full flex justify-between text-sm font-medium p-4`}
            onClick={() => setFieldNameShow("price")}
          >
            <span className="text-neutral-400">Price</span>
            <span>
              {`$${convertNumbThousand(
                rangePrices[0] / 1000
              )}k ~ $${convertNumbThousand(rangePrices[1] / 1000)}k`}
            </span>
          </button>
        ) : (
          <PriceRangeInput
            defaultValue={rangePrices}
            onChange={setRangePrices}
          />
        )}
      </div>
    );
  };

  return (
    <div>
      <div className="w-full space-y-5">
        {/*  */}
        {renderInputLocation()}
        {/*  */}
        {renderInputFilter("Categoría","category",categories,category,setCategory)}
        {renderInputFilter("Ciudad","city",cities,city,setCity)}
{/*         
        {renderInputPrice()} */}
      </div>
    </div>
  );
};

export default FilterFormSearch;
